import { LtInfiniteScroll } from '@lit-element/components/infinite-scroll'
import { LtLoading } from '@lit-element/components/loading'
import { LtMessage } from '@lit-element/components/message'
import { LtMessageBox } from '@lit-element/components/message-box'
import { LtNotification } from '@lit-element/components/notification'
import { LtPopoverDirective } from '@lit-element/components/popover'
import { LtContextmenu } from '@lit-element/components/contextmenu'

import type { Plugin } from 'vue'

export default [
  LtInfiniteScroll,
  LtLoading,
  LtMessage,
  LtMessageBox,
  LtNotification,
  LtPopoverDirective,
  LtContextmenu,
] as Plugin[]
